export default {
    methods: {
        getDatiTask() {
            return {
                data: "",
                prog: 0,
                titolo: "",
                descrizione: "",
                utenteCreazione: "",
                importoPrevisto: 0,
                destinazione: "",
                tipologia: "",
                oraInizio: null,
                oraFine: null,
                giornoIntero: false,
                codAnagrafica: "",
                completato: false,
                partecipanti: [],
            }
        },

        getDatiCalendar() {
            return {
                data: "",
                prog: 0,
                descrizione: "",
                ore: 0,
                minuti: 0,
                utente: "",
                importo: 0,
                tipoImporto: "",
                destinazione: "",
                tipoOre: "",
                daFatturare: false,
                trasferta: false,
            }
        },

        getDurateRapide() {
            return [
                { label: '30m', minuti: 30 },
                { label: '1h', minuti: 60 },
                { label: '1h30', minuti: 90 },
                { label: '2h', minuti: 120 },
                { label: '3h', minuti: 180 },
            ]
        },

        getRules() {
            return {
                required: (value) => !!value || "Richiesto.",

                number: (value) => {
                    return (
                        (/^\d+$/g.test(value) && parseInt(value) > 0) || "Numero non valido."
                    );
                },

                numberOptional: (value) => {
                    if (value == undefined) return true;
                    if (value.length == 0) return true;
                    if (!/^\d+$/g.test(value) || parseInt(value) < 0)
                        return "Numero non valido.";
                },
            }
        },


    }
}